import { createContext, useContext, useState, useEffect } from 'react'
import { translations } from './translations'

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  let initialLang = 'nl'
  try {
    initialLang = localStorage.getItem('lang') || 'nl'
  } catch (e) {
    console.warn('localStorage not available:', e)
  }
  const [lang, setLang] = useState(initialLang)

  const t = (key) => translations[lang][key] || key

  useEffect(() => {
    try {
      localStorage.setItem('lang', lang)
    } catch (e) {
      console.warn('localStorage not available:', e)
    }
  }, [lang])

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
